import axios, { AxiosResponse } from 'axios'
import qs from 'qs'
import {
  iExtSystemObjecId,
  iMsgDataWithCount,
  iParamsMsgs,
  iReadSearchResult,
  iSubmDataWithCount
} from '../types/api.types'
import { iMsgAttachment, iMsgRes, iSubmRes } from '../types/msg.types'

// const delay = (t: number) => new Promise(resolve => setTimeout(resolve, t))

const HEADER_TOTAL = 'x-total-count'

const parseTotalHeader = (res: AxiosResponse) => parseInt(res.headers[HEADER_TOTAL])

class EkomApi {
  api = axios.create()
  preloadToken = ''
  preloadPromise: Promise<any> | null = null

  init = (apiUrl?: string) => {
    if (!apiUrl) {
      console.error('Neni API_EKOM_URL')
    }
    this.api = axios.create({
      baseURL: apiUrl,
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' }),
      headers: {
        'Content-Type': 'application/vnd.openapi+json'
      }
    })
    this.initPreload()
  }

  initPreload = () => {

    this.api.interceptors.request.use(async (config) => {
        if (config.url === '/api/users/preload') {
          return config
        }
        const token = config.headers!['Authorization'] as string
        if (token !== this.preloadToken) {
          this.preloadToken = token
          if (!this.preloadPromise) {
            this.preloadPromise = this.preloadUser()
              .finally(() => {
                this.preloadPromise = null // clear state
              })
          }
        }
        if (this.preloadPromise) {
          try {
            await this.preloadPromise
          } catch (e) {
            console.log('catch preload error', e)
          }
        }
        return config
      }
    )
  }

  preloadUser = () =>
    this.api.get(`/api/users/preload`)
      .then(res => res.data)

  getCountUnreadIncoming = (objectExtId?: string) =>
    this.api.get(`/api/incoming_messages/search`, { params: { limit: 0, is_read: false, objectExtId: objectExtId } })
      .then(parseTotalHeader)

  getCountUnreadOutgoing = (objectExtId?: string) =>
    this.api.get(`/api/outgoing_messages/search`, { params: { limit: 0, is_read: false, objectExtId: objectExtId } })
      .then(parseTotalHeader)

  getCountIncoming = (objectExtId?: string) =>
    this.api.get(`/api/incoming_messages/search`, { params: { limit: 0, objectExtId: objectExtId } })
      .then(parseTotalHeader)

  getCountOutgoing = (objectExtId?: string) =>
    this.api.get(`/api/outgoing_messages/search`, { params: { limit: 0, objectExtId: objectExtId } })
      .then(parseTotalHeader)

  getCountSubmissions = (objectExtId?: string) =>
    this.api.get(`/api/submissions/search`, { params: { limit: 0, objectExtId: objectExtId } })
      .then(parseTotalHeader)

  getMsgIncomingSearch = (params?: iParamsMsgs): Promise<iMsgDataWithCount> =>
    this.api.get<iMsgRes[]>(`/api/incoming_messages/search`, { params: params })
      .then(res => ({ data: res.data, totalCount: parseTotalHeader(res) }))

  getMsgOutgoingSearch = (params?: iParamsMsgs): Promise<iMsgDataWithCount> =>
    this.api.get<iMsgRes[]>(`/api/outgoing_messages/search`, { params: params })
      .then(res => ({ data: res.data, totalCount: parseTotalHeader(res) }))

  getSubmissionsSearch = (params?: iParamsMsgs): Promise<iSubmDataWithCount> =>
    this.api.get<iSubmRes[]>(`/api/submissions/search`, { params: params })
      .then(res => ({ data: res.data, totalCount: parseTotalHeader(res) }))

  getMsgIncomingDetail = (id: string) =>
    this.api.get<iMsgRes>(`/api/incoming_messages/${id}`)
      .then(res => res.data)

  getMsgOutgoingDetail = (id: string) =>
    this.api.get<iMsgRes>(`/api/outgoing_messages/${id}`)
      .then(res => res.data)

  getSubmissionDetail = (id: string) =>
    this.api.get<iSubmRes>(`/api/submissions/${id}`)
      .then(res => res.data)

  getMsgIncomingDetailFiles = (id: string) =>
    this.api.get<iMsgAttachment[]>(`/api/incoming_messages/${id}/attachments`)
      .then(res => res.data)

  getMsgOutgoingDetailFiles = (id: string) =>
    this.api.get<iMsgAttachment[]>(`/api/outgoing_messages/${id}/attachments`)
      .then(res => res.data)

  viewMsgIncoming = (id: string) =>
    this.api.post(`/api/incoming_message_reads`, { message: `/api/incoming_messages/${id}` })
      .then(res => res.data)

  viewBulkMsgIncoming = (ids: string[]) =>
    this.api.post(`/api/incoming_message_reads/bulk_create`, { messages: ids.map(id => `/api/incoming_messages/${id}`) })
      .then(res => res.data)

  viewMsgOutgoing = (id: string) =>
    this.api.post(`/api/outgoing_message_reads`, { message: `/api/outgoing_messages/${id}` })
      .then(res => res.data)

  viewBulkMsgOutgoing = (ids: string[]) =>
    this.api.post(`/api/outgoing_message_reads/bulk_create`, { messages: ids.map(id => `/api/outgoing_messages/${id}`) })
      .then(res => res.data)

  getMsgIncomingReads = (id: string) =>
    this.api.get(`/api/incoming_messages/${id}/reads`)
      .then(res => res.data)

  getMsgOutgoingReads = (id: string) =>
    this.api.get(`/api/outgoing_messages/${id}/reads`)
      .then(res => res.data)

  searchMsgsReadIncoming = (extSystemObjectIds: iExtSystemObjecId[]) =>
    this.api.post<iReadSearchResult[]>(`/api/incoming_messages/read_messages/search`, { systemExtIdObjectExtId: extSystemObjectIds })
      .then(res => res.data)

  searchMsgsReadOutgoing = (extSystemObjectIds: iExtSystemObjecId[]) =>
    this.api.post<iReadSearchResult[]>(`/api/outgoing_messages/read_messages/search`, { systemExtIdObjectExtId: extSystemObjectIds })
      .then(res => res.data)

}

export default new EkomApi()




